<template>
  <div>
    <form @submit.prevent action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Visualizar Informações do Sócio e Cadastrar</p>
        </header>

        <section class="modal-card-body">
          <div class="tile is-ancestor">
            <div class="tile is-vertical">
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Nome do Sócio">
                      <b-input
                        placeholder="Ex.: Rodolpho Abrantes Junior"
                        size="is-medium"
                        v-model="associado.nome"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent is-3">
                  <article class="tile is-child">
                    <b-field label="Sexo">
                      <b-select v-model="associado.sexo" size="is-medium" required expanded disabled>
                        <option>Feminino</option>
                        <option>Masculino</option>
                        <option>Não Informado</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="CPF">
                      <b-input
                        placeholder="Ex.: 123.456.789-01"
                        v-model="associado.cpf"
                        size="is-medium"
                        v-mask="'###.###.###-##'"
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Data de Nascimento">
                      <b-input
                        placeholder="Ex.: 20/12/2012"
                        v-model="associado.nascimento.data"
                        size="is-medium"
                        v-mask="'##/##/####'"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Profissão Atual">
                      <b-input
                        placeholder="Ex.: Agricultor"
                        size="is-medium"
                        v-model="associado.profissao_atual"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Telefone Celular">
                      <b-input
                        placeholder="Ex.: (00) 0 0000-0000"
                        v-model="associado.telefone_celular"
                        size="is-medium"
                        v-mask="'(##) # ####-####'"
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->

              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Logradouro">
                      <b-input
                        placeholder="Ex.: Rua João Sebastião"
                        size="is-medium"
                        v-model="associado.endereco.rua"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Bairro">
                      <b-input
                        placeholder="Ex.: Bairro Jardim Azul"
                        size="is-medium"
                        v-model="associado.endereco.bairro"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Número">
                      <b-input
                        placeholder="Ex.: 1090"
                        size="is-medium"
                        v-model="associado.endereco.numero"
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="CEP">
                      <b-input
                        placeholder="Ex.: 63000-090"
                        v-model="associado.endereco.cep"
                        size="is-medium"
                        v-mask="'#####-###'"
                        required
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
              <div class="tile">
                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Estado">
                      <b-select
                        v-model="associado.endereco.estado"
                        size="is-medium"
                        required
                        expanded
                        disabled
                      >
                        <option>{{associado.endereco.estado}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Cidade">
                      <b-select
                        v-model="associado.endereco.cidade"
                        size="is-medium"
                        required
                        expanded
                        disabled
                      >
                        <option>{{associado.endereco.cidade}}</option>
                      </b-select>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Telefone Fixo">
                      <b-input
                        placeholder="Ex.: (00) 0000-0000"
                        v-model="associado.telefone_fixo"
                        size="is-medium"
                        v-mask="'(##) ####-####'"
                        disabled
                      ></b-input>
                    </b-field>
                  </article>
                </div>

                <div class="tile is-parent">
                  <article class="tile is-child">
                    <b-field label="Data de Ingresso" message="Preecha esse campo!">
                      <b-input
                        placeholder="Ex.: 12/01/2000"
                        v-model="data_ingresso"
                        size="is-medium"
                        required
                        v-mask="'##/##/####'"
                      ></b-input>
                    </b-field>
                  </article>
                </div>
              </div>
              <!--tile-->
            </div>
            <!--tile is-vertical-->
          </div>
          <!--tile is-ancestor-->
        </section>

        <footer class="modal-card-foot">
          <button class="button is-success" @click="subscribePartner">Cadastrar</button>
          <button class="button is-danger" @click="closeModal">Cancelar</button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ["associado"],
  data() {
    return {
      data_ingresso: null,
      associacao: {
        _associacao: this.$cookies.get("IDASSOCIACAO"),
        data_ingresso: null,
        periodos_arquivamento: [],
        isActive: true,
        tipo: ["Socio"],
        score: null,
        mensalidade: {},
        frequencia: {
          status: null,
          faltas: 0
        }
      }
    };
  },
  computed: {
    successAddPartner() {
      return this.$store.getters["associados/getIsSuccess"];
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },

    validateForm() {
      if (!this.data_ingresso)
        return "Insira a Data de Ingresso!";
      return;
    },

    async subscribePartner() {
      let error = this.validateForm();
      if (error) {
        this.$alert("Aviso!", error, "danger");
        return;
      }

      let socio = { _id: this.associado["_id"] };
      this.associacao.data_ingresso = this.transformDateToISOString(this.data_ingresso);
      socio["associacoes"] = {[`${this.$cookies.get("IDASSOCIACAO")}`]: this.associacao};

      await this.$store.dispatch("associados/addSocioAssociacaoInFirestore", socio);

      if (this.successAddPartner) {
        //Adiciona a referencia do sócio na associação
        await this.$store.dispatch("associacao/addReferenceOfPartnerInFirestore", socio._id);

        this.$alert("Sucesso!", "Sócio Cadastrado!", "success");
        this.$store.commit("associados/setIsSuccess", false);
        this.closeModal();
      } else {
        this.$alert("Erro!", "Erro ao Cadastrar Sócio!", "danger");
      }
    },

    transformDateToISOString(oldDate) {
      let date = oldDate.split("/");
      return date[2]+"-"+date[1]+"-"+date[0]+"T03:00:00.000Z";
    }
  },
  mounted() {
    this.associado.nascimento.data = new Date(this.associado.nascimento.data).toLocaleDateString()
    this.associado.endereco.estado = this.associado.endereco.estado;
    this.associado.endereco.cidade = this.associado.endereco.cidade;
  },
};
</script>

<style scoped>
@media screen and (max-width: 1088px) {
  .modal .animation-content .modal-card {
    overflow: scroll !important;
  }
}
</style>